// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"fda86dce","117":"15d88378","133":"0d50f056","152":"217357c8","205":"ab1126d7","210":"bc005b17","488":"93492c12","611":"7ee4309f","663":"e370b640","665":"c998c4e0","727":"38813ef4","763":"f8f863d5"}[chunkId] + ".chunk.js";
};